import { Col, Row } from 'antd';
import React, { useState } from 'react';
import AdvancedForm from '../AdvancedForm/AdvancedForm';
import { translate } from '@portal/services/i18n';
import { Divider } from '@material-ui/core';

import { validateOnboardingDocument } from '@portal/utils/validate';

import { onboarding } from '@portal/config/app.json';
import { RightOutlined } from '@ant-design/icons';

interface IProps {
  fromOnboarding?: boolean;
  setFileSelected: (value: File) => void;
}

const ApprovalCompany = ({ fromOnboarding, setFileSelected }: IProps) => {
  const [fileSelectedModal, setFileSelectedModal] = useState(null);
  const onFileChange = (e) => {
    if (!validateOnboardingDocument(e)) {
      return;
    }

    setFileSelected(e.target.files[0]);
    setFileSelectedModal(e.target.files[0]);
  };

  return (
    <div
      className={
        'approval-company' +
        (fromOnboarding ? ' approval-company-onboarding' : '')
      }
      onClick={() => {
        const fileInput = document?.getElementById('approval-company-file');
        if (fileInput) {
          fileInput.click();
        }
      }}
    >
      <AdvancedForm>
        <Row className="approval-company__wrapper">
          <Col className="approval-company__wrapper__item">
            <div className="approval-company__wrapper__item__content">
              <img
                className="approval-company__wrapper__item__content__img"
                src="assets/svg/icons/document_icon.svg"
                alt={translate(
                  'PAGES.AUTH.REGISTER.ONBOARD.PJ.APPROVAL_COMPANY.FORM.ATTORNEY.LABEL'
                )}
              />
              <p>
                <strong>
                  {translate(
                    'PAGES.AUTH.REGISTER.ONBOARD.PJ.APPROVAL_COMPANY.FORM.ATTORNEY.LABEL'
                  )}
                  <br />
                </strong>
                {translate(
                  'PAGES.AUTH.REGISTER.ONBOARD.PJ.APPROVAL_COMPANY.FORM.ATTORNEY.DESCRIPTION'
                )}
              </p>
            </div>
          </Col>
          <Col className="approval-company__wrapper__upload">
            <div className="approval-company__wrapper__item__content justify-content-between">
              <div className="onboarding-user-photo">
                {!fileSelectedModal ? (
                  <div className="onboarding-user-photo__container">
                    <div className="onboarding-user-photo__title">
                      {onboarding.maxFileSizeImage.enabled ? (
                        <p>
                          {translate(
                            'PAGES.AUTH.REGISTER.ONBOARD.PF.DOCUMENT.FORM.UPLOAD_MAX_IMAGE'
                          )}
                          {onboarding.maxFileSizeImage.sizeInMb}
                          {translate('SHARED.MB')}
                        </p>
                      ) : null}
                      {onboarding.maxFileSizePdf.enabled ? (
                        <p>
                          {translate(
                            'PAGES.AUTH.REGISTER.ONBOARD.PF.DOCUMENT.FORM.UPLOAD_MAX_PDF'
                          )}
                          {onboarding.maxFileSizePdf.sizeInMb}
                          {translate('SHARED.MB')}
                        </p>
                      ) : null}
                    </div>
                    <input
                      className="onboarding-user-photo__input"
                      type="file"
                      name="file"
                      id="approval-company-file"
                      onChange={onFileChange}
                    />
                  </div>
                ) : (
                  <div>
                    <div className="message-modal__fileSelected-button">
                      <span>
                        <img
                          src={'/assets/svg/upload.svg'}
                          alt="upload image"
                        />
                      </span>
                      <div className="message-modal__fileSelected-name">
                        <p className="message-modal__fileSelected-title">
                          {translate(
                            'PAGES.AUTH.REGISTER.ONBOARD.PF.DOCUMENT.FORM.UPLOAD_ACCOMPLISHED'
                          )}
                        </p>
                      </div>
                    </div>
                    <div className="upload-again__container">
                      <label htmlFor="approval-company-file-again">
                        <p className="message-modal__fileSelected-text">
                          {translate(
                            'PAGES.AUTH.REGISTER.ONBOARD.PF.DOCUMENT.FORM.UPLOAD_AGAIN'
                          )}
                        </p>
                      </label>
                      <input
                        type="file"
                        name="file-again"
                        id="approval-company-file-again"
                        onChange={onFileChange}
                      />
                    </div>
                  </div>
                )}
              </div>
              <span className="arrow" style={{ float: 'right' }}>
                <RightOutlined
                  style={{
                    color: 'black',
                    fontSize: 20,
                  }}
                />
              </span>
            </div>
          </Col>
        </Row>
        <Divider />
      </AdvancedForm>
    </div>
  );
};

export default ApprovalCompany;
